import React from 'react'
import TableContent from '../../components/TableContent'
const url = 'connector/emails'
const item = 'Email'
const items = 'Emails'

const ConnectorEmail = () => {
  return <TableContent url={url} type={'connector-email'} item={item} items={items} />
}
export default ConnectorEmail
